import { h, Component } from 'preact';
import { connect } from 'preact-redux';
import { suggestionsSelector } from 'app/desktop/selectors/locationSuggestions';
import LocationSuggestions from './LocationSuggestions';
import LocationDefaultSuggestions from './LocationDefaultSuggestions';
import { closeSearch } from 'app/desktop/actions/search';
import { checkExperiment } from 'app/common/actions/flags';
import RenderLocationErrorHtml from 'app/common/components/RenderLocationErrorHtml';
import {
  searchByLocation,
  clearAllRecentLocations,
  removeRecentLocation,
  getCurrentPosition,
  prefillLocation,
} from 'app/common/actions/locationSearch';

/**
 * The autocomplete result of location search
 */
export class LocationSearchResult extends Component {
  constructor(props) {
    super(props);

    this.renderTypeahead = this.renderTypeahead.bind(this);
    this.renderError = this.renderError.bind(this);
  }

  componentDidMount() {
    this.props.checkExperiment('enableLocationLink');
  }

  renderError() {
    const { errorStatus, keyword, flags } = this.props;
    return (
      <RenderLocationErrorHtml
        errorStatus={errorStatus}
        keyword={keyword}
        flags={flags}
      />
    );
  }

  /**
   * Render search result or default content
   */
  renderTypeahead() {
    const { keyword, errorStatus } = this.props;

    if (errorStatus) {
      return this.renderError();
    }

    // if keyword is empty
    if (!keyword.length) {
      return <LocationDefaultSuggestions {...this.props} />;
    }

    return <LocationSuggestions {...this.props} />;
  }

  render() {
    const { search, errorStatus } = this.props;
    if (search.context !== 'location' && !errorStatus) {
      return null;
    }

    return (
      <div
        className="ls-search-result typeahead-location typeahead-response"
        id="ls-search-results"
        aria-hidden="false"
        data-bhw="locationAutocomplete"
        style={{ display: 'block' }}
      >
        {this.renderTypeahead()}
      </div>
    );
  }
}

export default connect(
  suggestionsSelector,
  {
    searchByLocation,
    clearAllRecentLocations,
    removeRecentLocation,
    getCurrentPosition,
    prefillLocation,
    closeSearch,
    checkExperiment,
  }
)(LocationSearchResult);
